export default "__VITE_ASSET__141b5db7__"